import {FC, useState, useEffect} from 'react'
import Button from 'react-bootstrap/Button'
import {Modal} from 'react-bootstrap'
import Api from '../../../../../thesis-and-dissertations/helpers/api'
import {toast} from 'react-toastify'
import Select from 'react-select'

const api = new Api()

type Props = {
  showFormModal: boolean
  handleCloseFormModal: any
  formData: any
}

const FormPage: FC<Props> = ({showFormModal, handleCloseFormModal, formData}) => {
  const [loading, setLoading] = useState(false)
  const [show, setShow] = useState(false)
  const [formValue, setFormValue] = useState<any>({})
  const [dataRole, setDataRole] = useState<any>([])
  const [errors, setErrors] = useState<any>({})

  useEffect(() => {
    setShow(showFormModal)

    if (showFormModal) {
      fetchDataRole()
    }

    if (formData) {
      setFormValue({...formData, ...{role_id: formData?.roles?.map((s: any) => s.roles_id)}})
    }
  }, [showFormModal])

  const fetchDataRole = (params = {}) => {
    api
      .getRoleAll({...params})
      .then((response: any) => {
        const data = response.data.data
        setDataRole(data)
      })
      .catch((error: any) => {
      })
  }

  const handleInput = (e: any, name: string) => {
    setFormValue({...formValue, [name]: e.target.value})
  }

  const handleClose = () => {
    setFormValue({})
    handleCloseFormModal(false)
    setShow(false)
    setErrors({})
  }

  const store = () => {
    setLoading(true)
    api
      .addUser({...formValue, code_phone: '62'})
      .then((response: any) => {
        setLoading(false)

        const {data} = response
        toast.success(data?.meta?.message ?? data?.message)
        handleClose()
      })
      .catch((error: any) => {
        setLoading(false)
        const {data} = error.response
        setErrors(data?.meta?.error ?? data?.meta?.message)
      })
  }

  const update = () => {
    setLoading(true)
    api
      .updateUser({...formValue, code_phone: '62'}, formValue?.id_hash)
      .then((response: any) => {
        setLoading(false)
        const {data} = response
        toast.success(data?.meta?.message ?? data?.message)
        handleClose()
      })
      .catch((error: any) => {
        setLoading(false)
        const {data} = error.response
        setErrors(data?.meta?.error ?? data?.meta?.message)
      })
  }

  const handleSubmit = () => {
    if (formValue?.id_hash) {
      update()
      return
    }

    store()
  }

  return (
    <Modal show={show} onHide={handleClose} size='lg'>
      <Modal.Header closeButton>
        <Modal.Title>{formValue?.id ? 'Edit' : 'Tambah'} User</Modal.Title>
      </Modal.Header>
      <div>
        <Modal.Body>
          <div className='row'>
            <div className='col-md-6'>
              <p>Nama Awal</p>
              <input
                type='text'
                className={`form-control mt-2 ${errors?.firstname ? 'border-danger' : ''}`}
                value={formValue?.firstname}
                onChange={(e) => handleInput(e, 'firstname')}
              />

              {errors?.firstname ? <p className='text-danger mt-1'>{errors?.firstname}</p> : null}
            </div>

            <div className='col-md-6'>
              <p>Nama Akhir</p>
              <input
                type='text'
                className={`form-control mt-2 ${errors?.lastname ? 'border-danger' : ''}`}
                value={formValue?.lastname}
                onChange={(e) => handleInput(e, 'lastname')}
              />

              {errors?.lastname ? <p className='text-danger mt-1'>{errors?.lastname}</p> : null}
            </div>

            <div className='col-md-6 mt-5'>
              <p>Jenis Kelamin</p>
              <select
                name='gender'
                className={`form-control mt-2 ${errors?.gender ? 'border-danger' : ''}`}
                value={formValue?.gender}
                onChange={(e) => handleInput(e, 'gender')}
              >
                <option value=''>--Pilih Jenis Kelamin--</option>
                <option value='1'>Laki-laki</option>
                <option value='0'>Perempuan</option>
              </select>

              {errors?.gender ? <p className='text-danger mt-1'>{errors?.gender}</p> : null}
            </div>

            <div className='col-md-6 mt-5'>
              <p>Email</p>
              <input
                type='email'
                className={`form-control mt-2 ${errors?.email ? 'border-danger' : ''}`}
                value={formValue?.email}
                onChange={(e) => handleInput(e, 'email')}
              />
              {errors?.email ? <p className='text-danger mt-1'>{errors?.email}</p> : null}
            </div>

            <div className='col-md-6 mt-5'>
              <p>Role</p>
              <Select
                theme={(theme) => ({
                  ...theme,
                  borderRadius: 0,
                })}
                className={`mt-2 ${errors?.role_id ? 'border-danger' : ''}`}
                placeholder='--Pilih Role--'
                isMulti={true}
                options={dataRole}
                value={formValue?.roles}
                getOptionLabel={(opt: any) => opt?.roles_name}
                getOptionValue={(opt: any) => opt?.roles_id}
                onChange={(selected) => {
                  setFormValue({
                    ...formValue,
                    roles: selected,
                    role_id: selected.map((s) => s.roles_id),
                  })
                }}
                isLoading={false}
              />
              {errors?.role_id ? <p className='text-danger mt-1'>{errors?.role_id}</p> : null}
            </div>

            <div className='col-md-6 mt-5'>
              <p>No. Telepon</p>
              <input
                type='number'
                className={`form-control mt-2 ${errors?.phone_number ? 'border-danger' : ''}`}
                value={formValue?.phone_number}
                onChange={(e) => handleInput(e, 'phone_number')}
              />
              {errors?.phone_number ? (
                <p className='text-danger mt-1'>{errors?.phone_number}</p>
              ) : null}
            </div>

            <div className='col-md-6 mt-5'>
              <p>Password</p>
              <input
                type='password'
                className={`form-control mt-2 ${errors?.password ? 'border-danger' : ''}`}
                onChange={(e) => handleInput(e, 'password')}
              />
              {errors?.password ? <p className='text-danger mt-1'>{errors?.password}</p> : null}
            </div>

            <div className='col-md-6 mt-5'>
              <p>Konfirmasi Password</p>
              <input
                type='password'
                className={`form-control mt-2 ${
                  errors?.password_confirmation ? 'border-danger' : ''
                }`}
                onChange={(e) => handleInput(e, 'password_confirmation')}
              />
              {errors?.password_confirmation ? (
                <p className='text-danger mt-1'>{errors?.password_confirmation}</p>
              ) : null}
            </div>

            <div className='col-md-6 mt-5'>
              <p>Status</p>
              <select
                name='status'
                className={`form-control mt-2 ${errors?.status ? 'border-danger' : ''}`}
                value={formValue?.status ?? ''}
                onChange={(e) => handleInput(e, 'status')}
              >
                <option value=''>--Pilih Status--</option>
                <option value='1'>Aktif</option>
                <option value='0'>Nonaktif</option>
              </select>
              {errors?.status ? <p className='text-danger mt-1'>{errors?.status}</p> : null}
            </div>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button type='button' variant='secondary' onClick={handleClose} disabled={loading}>
            Batalkan
          </Button>
          <Button variant='primary' type='button' disabled={loading} onClick={handleSubmit}>
            {loading ? 'Loading' : 'Simpan'}
          </Button>
        </Modal.Footer>
      </div>
    </Modal>
  )
}

const FormModal: FC<Props> = ({showFormModal, handleCloseFormModal, formData}) => {
  return (
    <FormPage
      showFormModal={showFormModal}
      handleCloseFormModal={handleCloseFormModal}
      formData={formData}
    />
  )
}

export default FormModal
